/**
 * ENTRAR PELO LINK DE CONVITE — caso E das regras de 06/10 (repo instituicoes-ensino).
 *
 * "Quem entra por link de convite já entra aprovado. Gerar o link é a aprovação do educador, que
 * pode desativar o link a qualquer hora." Sem conta, a página manda entrar e volta para cá.
 */
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import Nav from "../../components/nav";
import { useGlobalState } from "../../global-state-context";
import { Convite, buscarInstituicao, entrarPorConvite, lerConvite } from "../../instituicao/api";
import { Instituicao } from "../../instituicao/modelo";
import { paraOndeVoltar } from "../login/para-onde-voltar";

import "../admin/regras.scss";
import "../../instituicao/minha-instituicao.scss";

export default function PaginaDoConvite() {
  const { codigo = "" } = useParams();
  const globalState = useGlobalState();
  const navigate = useNavigate();
  const local = useLocation();
  const [convite, setConvite] = useState<Convite | null | undefined>(undefined);
  const [inst, setInst] = useState<Instituicao | null>(null);
  const [estado, setEstado] = useState<"" | "entrando" | "dentro" | "erro">("");
  const [erro, setErro] = useState("");

  const logado = !!globalState?.authUser?.emailVerified;

  useEffect(() => {
    document.title = "Convite · HQ-Lab";
    return () => {
      document.title = "HQ-Lab";
    };
  }, []);

  useEffect(() => {
    if (!globalState) return;
    if (!logado) {
      navigate("/login", { replace: true, state: paraOndeVoltar(local, !!globalState.authUser) });
      return;
    }
    void lerConvite(codigo).then(async (c) => {
      setConvite(c);
      if (c) setInst(await buscarInstituicao(c.instituicaoId));
    });
  }, [globalState, logado, codigo, navigate, local]);

  async function entrar() {
    if (!convite || !globalState?.appUser) return;
    setEstado("entrando");
    const u = globalState.appUser;
    const r = await entrarPorConvite(convite, { uid: u.Id(), nome: u.Name(), email: u.Email() });
    if (r.ok) setEstado("dentro");
    else {
      setEstado("erro");
      setErro(r.erro || "Não deu. Tente de novo.");
    }
  }

  const valido = !!convite && convite.ativo && inst?.situacao === "ativa";

  return (
    <>
      <Nav />
      <main className="regras-painel" data-testid="pagina-convite">
        <h1>Convite para uma escola</h1>
        {convite === undefined ? (
          <p>Lendo o convite…</p>
        ) : !valido ? (
          <p className="regras-sem-acesso">
            Este link de convite não vale mais. Peça um link novo ao seu professor, ou procure a sua
            escola em <Link to="/minha-conta">Minha conta</Link>.
          </p>
        ) : estado === "dentro" ? (
          <p className="inst-aviso inst-aviso-ok" role="status">
            Pronto: você entrou em {inst!.nome} como {convite!.papel === "educador" ? "educador" : "estudante"}.{" "}
            <Link to="/minha-conta">Ver em Minha conta</Link>
          </p>
        ) : (
          <>
            <p>
              Você foi convidado para <strong>{inst!.nome}</strong> ({inst!.cidade}) como{" "}
              {convite!.papel === "educador" ? "educador" : "estudante"}. Quem entra pelo convite já
              entra aprovado.
            </p>
            {estado === "erro" && <p className="inst-aviso inst-aviso-erro">{erro}</p>}
            <button type="button" className="botao-secundario" disabled={estado === "entrando"} onClick={entrar}>
              Entrar na escola
            </button>
          </>
        )}
      </main>
    </>
  );
}
